module.exports = __webpack_public_path__ + "img/enigma-red-2.92260cc8.png";